<template>
  <div class="svg">
    <img v-if="image.length" :src="image">
  </div>
</template>

<script type="text/javascript">
  export default {
    data () {
      return {
      	image: ''
      }
    },
    props: ['type'],
    mounted () {
    	//this.image = `https://www.liyu.fun/img/loading/${this.type}.svg`
			this.image = require("./loading.svg");
    }
  }
</script>

<style >
  .svg img{
      width: 50px;
  }
</style> 


// WEBPACK FOOTER //
// src/vue-nice-loading/src/components/Spinner.vue